import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mail\">\r\n\t<path d=\"M992 128H32c-19.2 0-32 12.8-32 32v704c0 19.2 12.8 32 32 32h960c19.2 0 32-12.8 32-32V160c0-19.2-12.8-32-32-32z m-80 64L502.4 604.8 89.6 192h822.4zM64 832V256l416 416c6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6L960 236.8V832H64z\" fill=\"#212121\" p-id=\"4283\">\r\n\t</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol